import penthouseImage from "@/assets/property-penthouse.jpg?w=800&format=webp&quality=80";
import brownstoneImage from "@/assets/property-brownstone.jpg?w=800&format=webp&quality=80";
import condoImage from "@/assets/property-condo.jpg?w=800&format=webp&quality=80";
import floorplanPenthouse from "@/assets/floorplan-penthouse.jpg";
import floorplanBrownstone from "@/assets/floorplan-brownstone.jpg";
import floorplanCondo from "@/assets/floorplan-condo.jpg";
import galleryKitchen from "@/assets/gallery-kitchen.jpg";
import galleryBedroom from "@/assets/gallery-bedroom.jpg";
import galleryBathroom from "@/assets/gallery-bathroom.jpg";

export interface Property {
  id: number;
  slug: string;
  title: string;
  address: string;
  neighborhood: string;
  price: string;
  pricePerSqft: string;
  beds: number;
  baths: number;
  sqft: string;
  yearBuilt: number;
  lotSize: string;
  propertyType: string;
  image: string;
  gallery: string[];
  floorplan: string;
  description: string;
  features: string[];
  amenities: string[];
}

export const properties: Property[] = [
  {
    id: 1,
    slug: "magnificent-mile-penthouse",
    title: "Magnificent Mile Penthouse",
    address: "680 N Lake Shore Dr, Chicago, IL 60611",
    neighborhood: "Streeterville",
    price: "$4,200,000",
    pricePerSqft: "$1,000",
    beds: 4,
    baths: 4,
    sqft: "4,200",
    yearBuilt: 2019,
    lotSize: "N/A",
    propertyType: "Penthouse",
    image: penthouseImage,
    gallery: [penthouseImage, galleryKitchen, galleryBedroom, galleryBathroom],
    floorplan: floorplanPenthouse,
    description: "Experience the pinnacle of luxury living in this stunning penthouse overlooking Lake Michigan and the Chicago skyline. This exceptional residence features floor-to-ceiling windows, designer finishes throughout, and an open floor plan perfect for entertaining. The gourmet kitchen boasts top-of-the-line appliances, custom cabinetry, and a large center island. The primary suite offers breathtaking views, a spa-like bathroom, and generous closet space.",
    features: [
      "Floor-to-ceiling windows with panoramic views",
      "Private elevator entrance",
      "Smart home technology throughout",
      "Heated floors in all bathrooms",
      "Custom Italian cabinetry",
      "Wolf and Sub-Zero appliances",
      "Wine storage room",
      "Two private terraces",
    ],
    amenities: [
      "24/7 Doorman & Concierge",
      "Fitness Center & Spa",
      "Rooftop Pool & Sundeck",
      "Private Residents Lounge",
      "Valet Parking",
      "Pet-Friendly Building",
    ],
  },
  {
    id: 2,
    slug: "lincoln-park-brownstone",
    title: "Lincoln Park Brownstone",
    address: "2145 N Fremont St, Chicago, IL 60614",
    neighborhood: "Lincoln Park",
    price: "$2,850,000",
    pricePerSqft: "$559",
    beds: 5,
    baths: 4,
    sqft: "5,100",
    yearBuilt: 1892,
    lotSize: "3,750 sqft",
    propertyType: "Single Family",
    image: brownstoneImage,
    gallery: [brownstoneImage, galleryKitchen, galleryBedroom, galleryBathroom],
    floorplan: floorplanBrownstone,
    description: "A masterfully restored Lincoln Park brownstone combining historic charm with modern luxury. This stunning home features original architectural details including ornate crown moldings, decorative fireplaces, and hardwood floors, all thoughtfully updated with contemporary amenities. The chef's kitchen opens to a sun-filled family room with French doors leading to a private garden. Five spacious bedrooms across three levels provide ample space for family and guests.",
    features: [
      "Original restored hardwood floors",
      "Five decorative fireplaces",
      "Chef's kitchen with butler's pantry",
      "Private landscaped garden",
      "Attached two-car garage",
      "Full finished basement",
      "Third floor primary suite",
      "New HVAC and electrical systems",
    ],
    amenities: [
      "Walk to Lincoln Park Zoo",
      "Steps from Oz Park",
      "Top-rated school district",
      "Nearby boutique shopping",
      "Close to public transit",
      "Tree-lined street",
    ],
  },
  {
    id: 3,
    slug: "gold-coast-luxury-condo",
    title: "Gold Coast Luxury Condo",
    address: "1030 N State St, Chicago, IL 60610",
    neighborhood: "Gold Coast",
    price: "$1,950,000",
    pricePerSqft: "$696",
    beds: 3,
    baths: 3,
    sqft: "2,800",
    yearBuilt: 2015,
    lotSize: "N/A",
    propertyType: "Condominium",
    image: condoImage,
    gallery: [condoImage, galleryKitchen, galleryBedroom, galleryBathroom],
    floorplan: floorplanCondo,
    description: "Sophisticated Gold Coast living awaits in this beautifully appointed three-bedroom condominium. Enjoy elegant city views from the expansive living spaces featuring 10-foot ceilings, custom millwork, and premium finishes. The open-concept design seamlessly connects the living, dining, and kitchen areas, perfect for both daily living and entertaining. Located on one of Chicago's most prestigious streets, you'll be steps from Oak Street Beach, world-class dining, and luxury shopping.",
    features: [
      "10-foot ceilings throughout",
      "Custom millwork and built-ins",
      "Gourmet kitchen with breakfast bar",
      "Primary suite with city views",
      "In-unit washer and dryer",
      "Hardwood floors throughout",
      "Motorized window treatments",
      "Two deeded parking spaces",
    ],
    amenities: [
      "Full-service building",
      "On-site fitness center",
      "Outdoor terrace with grills",
      "Business center",
      "Guest suites available",
      "Bike storage",
    ],
  },
];

export const getPropertyBySlug = (slug: string): Property | undefined => {
  return properties.find((p) => p.slug === slug);
};

export const getPropertyById = (id: number): Property | undefined => {
  return properties.find((p) => p.id === id);
};